import './about.style.css'
import { FaAward } from 'react-icons/fa'
import { VscFolderLibrary } from 'react-icons/vsc'

const About = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About me</h2>

      <div className="container about_container">
        <div className="aboutMe">
          <div className="aboutMeImage">
            <img
              src={'/assets/profile2_no_watermark.jpg'}
              alt="vivek padelkar"
            />
          </div>
        </div>

        <div className="aboutContent">
          <div className="aboutCards">
            <article className="aboutCard">
              <FaAward className="aboutCardIcon" />
              <h5>Experience</h5>
              <small>5+ years Working</small>
            </article>

            <article className="aboutCard">
              <VscFolderLibrary className="aboutCardIcon" />
              <h5>Projects</h5>
              <small>5+ completed</small>
            </article>
          </div>

          <p style={{ textAlign: 'start' }}>
            Hi ,I'm a full-stack Developer in Mumbai, IND. <br />I have 5+ years
            of experience as a Software developer and love working with React
            and other hip frameworks. I'm passionate about bringing both the
            technical and visual aspects of digital products to life. User
            experience, beautiful pixels and writing clean accessible, human
            code matters to me.
            <br />I have a <b>Bsc in Informtaion technology</b> and a
            <b> Certificate of Complete React Devloper</b> 2022 from Udemy,
            <br />
            I'm happiest when I'm creating, learning, exploring and thinking
            about how to make things better.feel free to reach out and say
            hello!😉
          </p>

          <a
            className="btn btn-primary"
            href="#contact"
            style={{ padding: '15px' }}
          >
            drop me a line
          </a>
        </div>
      </div>
    </section>
  )
}

export default About
